import * as React from 'react';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

export type StdDialogWizardContentProps<C extends React.ElementType = 'div'> = Omit<BoxProps<C>, 'component'> & {
  component?: C;
};

const StdDialogWizardContent = <C extends React.ElementType = 'div'>({
  children,
  component,
  ...other
}: StdDialogWizardContentProps<C>) => {
  return (
    <Box component={component ?? 'div'} display='flex' flex='1' flexDirection='column' {...other}>
      {children}
    </Box>
  );
};

export default StdDialogWizardContent;
